import { fireEvent, screen, within } from '@testing-library/react'
import userEvent from '@testing-library/user-event'

/**
 * Set a field's value in a single change event instead of one keystroke at a time.
 *
 * `userEvent.type` dispatches an event per character, and SchemaForm runs `mode: 'all'`
 * validation on every change — so typing an N-char string re-validates the whole form N
 * times. On heavy forms under CI contention that compounds into per-test timeouts. `fill`
 * fires one change, triggering a single validation pass, while still going through React's
 * onChange so RHF/Controller state updates exactly as it would for real input.
 *
 * Use for plain text/number inputs where per-keystroke behaviour isn't under test. When the
 * keystroke sequence itself matters (e.g. asserting intermediate validation), keep `type`.
 */
export const fill = async (labelText: string | RegExp, value: string) => {
  fireEvent.change(await screen.findByLabelText(labelText), { target: { value } })
}

export const selectOptionsByLabelText = async (labelText: string | RegExp, values: string | string[]) => {
  await userEvent.click(await screen.findByLabelText(labelText))

  if (Array.isArray(values)) {
    for (const value of values) {
      const list = await screen.findByRole('listbox', { name: labelText })

      const childOption = await within(list).findByText(value)

      await userEvent.click(childOption)
    }
  } else {
    const childOption = await within(await screen.findByRole('listbox', { name: labelText })).findByText(values)

    await userEvent.click(childOption)
  }
}
